export class GetFromBridge {
  static readonly type = '[Session] get from bridge';
}

export class GetFromCookie {
  static readonly type = '[Session] get from cookie';
}

export class GetFromMock {
  static readonly type = '[Session] get from mock';
}

export class SetMsisdnFromApp {
  static readonly type = '[Session] set msisdn from app';

  constructor(public params: { msisdn: string }) {
  }
}

export class SetLinkAccountFromApp {
  static readonly type = '[Session] set link account from app';

  constructor(public params: { fixedLineInfo: { linkAccountId: string, cliNumber: string } }) {
  }
}

export class GetKeyMapAWS {
  static readonly type = '[Session] get key map for AWS session initialization';

  constructor(public path?: string) {
  }
}
